/**
 * Single source of truth for product branding.
 * Swap these values (and the logo mark in components/brand/logo.tsx) to rebrand
 * the entire app — name, tagline, support links all read from here.
 *
 * 3.139 (the sponsor, 2026-10-09, relayed by the demo lane): the product's name
 * is HibirEVAP; "HibrEVAP" was a long-standing typo. Display text only: the
 * lowercase identifier `hibrevap` (client id, realm, header names, file names,
 * storage keys) is unchanged.
 */
export const branding = {
  name: "HibirEVAP",
  shortName: "HibirEVAP",
  tagline: "Hibir Enterprise Vulnerability Assessment Platform",
  company: "Hibir",
  year: 2026,
  supportUrl: "https://hibrevap.example/support",
  docsUrl: "https://hibrevap.example/docs",
} as const;

export type Branding = typeof branding;
